export const orderForOptions = [
    { value: 0, label: "Not Selected" },
    { value: 1, label: "Primary" },
    { value: 2, label: "Co-Applicant" },
    { value: 3, label: "Both" },
  ];
